import { apolloClient } from "@td/ui";
import CREATE_PRE_INTAKE_STATUS_MUTATION from "../mutations/create-pre-intake-status.graphql";

export const createPreIntakeStatus = async ({ consultationId, statusCd }) => {
  const { data: { createPreIntakeStatus: data } } = await apolloClient.mutate({
    mutation: CREATE_PRE_INTAKE_STATUS_MUTATION,
    variables: {
      consultationId,
      statusCd,
    },
  });

  return data;
};
